import { gql } from '@apollo/client'

type SmsType = 'CONTACT_ATTEMPT' | 'CLOSING' | 'CONTRACT_VALIDATION'
interface SendContactAttemptSmsMutationVariables {
  processingId: string
  smsType: SmsType
  projectId?: string
}

interface SendContactAttemptSmsMutationResponse {
  sendContactAttemptSms: boolean
}

export const SEND_CONTACT_ATTEMPT_SMS = gql`
  mutation sendContactAttemptSms($processingId: ID!, $smsType: SmsTypeEnum!, $projectId: ID) {
    sendContactAttemptSms(processingId: $processingId, smsType: $smsType, projectId: $projectId)
  }
`
export default SEND_CONTACT_ATTEMPT_SMS

export type {
  SendContactAttemptSmsMutationResponse,
  SendContactAttemptSmsMutationVariables,
  SmsType
}
